import React from "react";
import { getClassName } from "@sscs/utils";
import { ChevronDownIcon } from "../../icons";
import { IconButton } from "../index";
import styles from "./expandButton.module.scss";
const ExpandButton = ({ id, isExpanded, onClick, className, "aria-label": ariaLabel, }) => (React.createElement(IconButton, { id: id, onClick: onClick, "aria-expanded": isExpanded, "aria-label": ariaLabel, className: getClassName(styles["expand-button"], { [styles.expanded]: isExpanded }, className) },
    React.createElement(ChevronDownIcon, null)));
ExpandButton.displayName = "ExpandButton";
export default ExpandButton;
//# sourceMappingURL=ExpandButton.js.map